import { Component, OnInit, ElementRef, HostListener } from '@angular/core';
import { UsuarioService } from '../../../services/usuario.service';
import { FormBuilder, Validators } from '@angular/forms';
import { GeneralService } from 'src/app/services/general.service';
import Swal from 'sweetalert2';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
@Component({
  selector: 'app-busca-info',
  templateUrl: './busca-info.component.html',
  styleUrls: ['./busca-info.component.css']
})
export class BuscaInfoComponent implements OnInit {

constructor(
  private fb: FormBuilder,
  public _general: GeneralService,
  private usuarioService: UsuarioService,
  private eRef: ElementRef
) { }
  rutCuenta:string;
  tipo_usuario_name:string;
  usuario:any;

  rutBuscar:string;

  public muestraPerfil = true;
  public noHayInfo = true;
  public esmedico = false;

  usuario_buscado: any = {};
  rut = '';
  nombre: String;
  apellido_paterno:String;
  apellido_materno:String;
  fecha_nacimiento = '';
  telefono: Number;
  email:String;
  genero: String;
  direccion: String;
  numero:string;
  rest: String;
  comuna: String;
  region: String;
  especialidad: String;
  subespecialidad: String;
  titulo: String;
  fechaegreso: String;
  universidad: String;
  nombre_region:string;
  nombre_comuna:string;
  anio:string;
  mes:string;
  dia:string;
  fecha_chile:string;
  tipo_de_usuario:string;
  tipos_de_usuario: any[] = [];
 beneficiarios_data: any[] = [];
beneficiario_selected: any = null;
searchStrMain: string = '';

showDropdown = false;
loadingBeneficiarios = false;

private searchTimeout: any = null;



  largo_data:any = [];

  public rutABuscar = this.fb.group({
    rutBuscarPlataforma: [ '']
  });

  ngOnInit() {
    if (!sessionStorage.getItem('token')){ //sin session
      this.usuarioService.logout()
    }
    
    this.usuario = new EncriptacionService().getUserInfo();
    this.rutCuenta = this.usuario.rut;
    this.tipo_usuario_name = this.usuario.typ_name;    
  }


 @HostListener('document:click', ['$event'])
clickOutside(event: MouseEvent) {
  const target = event.target as HTMLElement;
  if (!this.eRef.nativeElement.contains(target)) {
    this.showDropdown = false;
  }
}

onBeneficiarioInputChange() {
  const valor = (this.searchStrMain || '').trim();

  this.beneficiario_selected = null;

  if (this.searchTimeout) {
    clearTimeout(this.searchTimeout);
  }

  if (valor.length < 4) {
    this.beneficiarios_data = [];
    this.showDropdown = false;
    return;
  }

  this.searchTimeout = setTimeout(() => {
    this.getBeneficiarios(valor);
  }, 300);
}

onInputFocus() {
  if (this.beneficiarios_data.length > 0 && (this.searchStrMain || '').trim().length >= 4) {
    this.showDropdown = true;
  }
}

getBeneficiarios(valor: string) {
  this.loadingBeneficiarios = true;

  this._general.postListarusuariosSistema(valor)
    .then((results: any[]) => {
      this.beneficiarios_data = (results || []).map(ben => {
        const nombre = ben.use_name || '';
        const paterno = ben.use_paternal_surname || '';
        const materno = ben.use_maternal_surname || '';
        const rut = ben.use_username || ben.use_rut || '';

        return {
          ...ben,
          nombre_completo: `${nombre} ${paterno} ${materno} : ${rut}`.replace(/\s+/g, ' ').trim()
        };
      });

      this.showDropdown = true;
      this.loadingBeneficiarios = false;
    })
    .catch(error => {
      this.beneficiarios_data = [];
      this.showDropdown = true;
      this.loadingBeneficiarios = false;

      Swal.fire({
        icon: 'warning',
        title: 'Error al cargar los usuarios.',
        timer: 2000
      });
    });
}

seleccionarBeneficiario(item: any) {
  this.beneficiario_selected = item;
  this.searchStrMain = item.nombre_completo;
  this.showDropdown = false;
}

  buscarRut() {
  if (!this.beneficiario_selected) {
    Swal.fire({
      icon: 'warning',
      title: 'Debe seleccionar un usuario de la lista.',
      timer: 2000
    });
    return;
  }

  this.rutBuscar = this.beneficiario_selected.use_username;
  this.usuario_buscado = {};

  const buscarSinPuntos = this.rutBuscar.split('.').join('');

  this.usuarioService.informacionPerfilContact(buscarSinPuntos, this.tipo_usuario_name)
    .subscribe((data: any) => {
      if (data.status == false) {
        this.noHayInfo = false;
        this.muestraPerfil = true;
        this.usuario_buscado = {};
      } else {
        this.rut = data.rut;
        this.nombre = data.nombre;
        this.apellido_paterno = data.apellido_paterno;
        this.apellido_materno = data.apellido_materno;
        this.fecha_nacimiento = ((data.fecha_nacimiento).split('T'))[0];
        this.anio = this.fecha_nacimiento.split('-')[0];
        this.mes = this.fecha_nacimiento.split('-')[1];
        this.dia = this.fecha_nacimiento.split('-')[2];
        this.fecha_chile = this.dia + "-" + this.mes + "-" + this.anio;
        this.telefono = data.telefono;
        this.email = data.email;
        this.genero = data.genero;
        this.direccion = data.calle;
        this.numero = data.numerocasa;
        this.rest = data.rest;
        this.comuna = data.comuna;
        this.region = data.region;
        this.especialidad = data.nombre_especialidad;
        this.subespecialidad = data.nombre_subespecialidad;
        this.titulo = data.titulo;
        this.fechaegreso = ((data.fecha_emision_titulo).split('T'))[0];
        this.universidad = data.nombre_institucion;

        if (data.tipo_usuario == 2) {
          this.tipo_de_usuario = 'PACIENTE';
          this.usuario_buscado.use_id = data.idusuario;
        }
        if (data.tipo_usuario == 1) {
          this.tipo_de_usuario = 'MEDICO';
          this.esmedico = true;
        }
        if (data.tipo_usuario == 7) {
          this.tipo_de_usuario = 'CONTACT CENTER';
        }
        if (data.tipo_usuario == 8) {
          this.tipo_de_usuario = 'COORDINADOR MEDICO';
        }

        this.muestraPerfil = false;
        this.tipos_de_usuario = data.user_types;
        this.noHayInfo = true;
      }
    });
}

}
